import actions from "@/store/filterBar/actions.js";
import getters from "@/store/filterBar/getters.js";
import mutations from "@/store/filterBar/mutations.js";
import createState from "@/store/filterBar/state.js";

const namespaced = true;

function createFilterBarStore() {
  return {
    namespaced,
    actions,
    getters,
    mutations,
    state: createState,
  };
}

export default createFilterBarStore;
